import React from "react";
import "../assets/css/fontawesome.css";
import "../assets/css/slick.css";
import "../assets/css/lightgallery.min.css";
import "../assets/css/animate.css";
import "../assets/css/style.css";
import Typewriter from "typewriter-effect";

const Describe = () => {
  return (
    <>
      <section
        class="st-hero st-style2 st-bg st-dynamic-bg"
        data-src="assets/img/hero-bg-2.jpg"
      >
        <div class="container">
          <div class="st-hero-text">
            <h1>
              Hi👋,
              <br />
              I'm <span>Vicky Dev</span>
            </h1>
            <p>
              <Typewriter
                options={{
                  autoStart: true,
                  loop: true,
                  deplay: 50,
                  strings: [
                    "I am an outstanding backend developer known for building robust APIs, managing system databases, and delivering seamless and efficient backend solutions.",
                  ],
                }}
              />
              {/* <Typewriter 
            options={{
              autoStart:true,
              loop:true,
              deplay:50,
              strings:[`I am a Web developer. I can provide clean code and pixel perfect design. <br /> I also make website more & more interactive with web animations.`]
            }}
          /> */}
            </p>
            {/* <p>I am a Web developer. I can provide clean code and pixel perfect design. <br />I also make website more & more interactive with web animations.</p> */}
            <div class="st-hero-social-links">
              <a
                href="https://web.facebook.com/profile.php?id=100094385412890"
                class="st-social-btn"
              >
                <i class="fab fa-facebook-f"></i>
              </a>
              <a href="https://wa.me/+2349167638933" class="st-social-btn">
                <i class="fab fa-whatsapp"></i>
              </a>
              <a href="https://github.com/vickymayowa" class="st-social-btn">
                <i class="fab fa-github"></i>
              </a>
              <a href="https://x.com/__MayowaDev02" class="st-social-btn">
                <i class="fab fa-twitter"></i>
              </a>
              <a
                href="https://www.linkedin.com/in/adebanjo-favour-%F0%9F%92%BB-217b1a251/"
                class="st-social-btn"
              >
                <i class="fab fa-linkedin"></i>
              </a>
              {/* <a href="mailto:favouradebanjo2@gmail.com" class="st-social-btn">
            <i class="fab fa-envelope" aria-hidden="true"></i>
          </a> */}
            </div>
          </div>
        </div>
        <svg x="0px" y="0px" viewBox="0 186.5 1920 113.5" class="st-hero-shape">
          <polygon points="-30,300 355.167,210.5 1432.5,290 1920,198.5 1920,300"></polygon>
        </svg>
      </section>
    </>
  );
};

export default Describe;
